import Vue from 'vue'
import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, ProspectState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'
import moment from 'moment'
import router from '@/router'

type ProspectGetter = GetterTree<ProspectState, RootState>

const state: ProspectState = {
  count: null,
  prospects: null,
  prospect: null,
  paginationParams: null,
  sortParams: null,
  limitParam: 20,
  filterParams: null
}

export const getters: ProspectGetter = {
  prospectsCountGetter: (state) => state.count,
  prospectsGetter: (state) => state.prospects,
  prospectGetter: (state) => state.prospect,
  prospectSortParamsGetter: (state) => state.sortParams,
  prospectFilterParamsGetter: (state) => state.filterParams,
  prospectLimitParamGetter: (state) => state.limitParam,
  prospectPaginationParamsGetter: (state) => state.paginationParams
}

export const actions: ActionTree<ProspectState, RootState> = {
  async getProspectsCountAction({commit, state}) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`)
    commit('getProspectsCountMutation', data)
    return data
  },
  async getProspectsEnCoursCountAction({commit, state}) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        enCours: 1
      }
    })
    return data
  },
  async getProspectsEnCoursCountByConseillerAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        enCours: 1,
        conseiller: id
      }
    })
    return data
  },
  async getProspectsPropositionEnCoursCountAction({commit, state}) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        enCours: 1,
        propositionEnCours: 1
      }
    })
    return data
  },
  async getProspectsPropositionEnCoursCountByConseillerAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        enCours: 1,
        propositionEnCours: 1,
        conseiller: id
      }
    })
    return data
  },
  async getProspectsNouvelEchangeATraiterCountAction({commit, state}) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        nouvelEchangeATraiter: true,
        refStatuts: ['E', 'Q', 'N', 'R']
      }
    })
    return data
  },
  async getProspectsNouvelEchangeATraiterCountByConseillerAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        nouvelEchangeATraiter: true,
        refStatuts: ['E', 'Q', 'N', 'R', 'CS', 'E2', 'MQ'],
        conseiller: id
      }
    })
    return data
  },
  async getProspectsEssaiEnCoursCountAction({commit, state}) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        enCours: 1,
        essaiEnCours: 1
      }
    })
    return data
  },
  async getProspectsEssaiEnCoursCountByConseillerAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        enCours: 1,
        essaiEnCours: 1,
        conseiller: id
      }
    })
    return data
  },
  async getProspectsNonAffectesCountAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        conseiller: 0
      }
    })
    return data
  },
  async getProspectsPropositionAFaireCountAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        conseiller: id,
        propositionEnCours: 0,
        refStatuts: ['Q', 'N']
      }
    })
    return data
  },
  async getProspectsARelancerCountAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        conseiller: id,
        propositionEnCours: 1,
        refStatuts: ['N'],
        dateEchangeMax: moment().subtract(10, 'days').format('DD-MM-YYYY')
      }
    })
    return data
  },
  async getProspectsEntrantsCountAction({commit, state}, id) {
    const {data} = await axios.get(`${apiUrl}/prospect/count`, {
      params: {
        refStatuts: ['E']
      }
    })
    return data
  },
  async getProspectsAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/prospect`, {
      params: {
        ...queryParams,
        limit: state.limitParam
      }
    })
    commit('saveProspectPaginationParamsMutation', data)
    commit('getProspectsMutation', data)
    return data
  },
  async getProspectByIdAction({commit}, id) {
    commit('resetProspectMutation')
    const {data} = await axios.get(`${apiUrl}/prospect/${id}`)
    commit('getProspectByIdMutation', data)
    return data
  },
  async saveProspectSortParamsAction({commit}, data) {
    commit('saveProspectSortParamsMutation', data)
  },
  async saveProspectFilterParamsAction({commit}, data) {
    commit('saveProspectFilterParamsMutation', data)
  },
  async saveProspectLimitParamAction({commit}, data) {
    commit('saveProspectLimitParamMutation', data)
  },
  async createProspectAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/prospect`, formParams)
    return data
  },
  async createProspectFastAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/prospect/fast`, formParams)
    return data
  },
  async createProspectMcoAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/prospect/mco`, formParams)
    return data
  },
  async createProspectClientAction({commit}, {id, formParams}) {
    const {data} = await axios.post(`${apiUrl}/prospect/${id}/client`, formParams)
    return data
  },
  async updateProspectAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/prospect/${id}`, formParams)
    return data
  },
  async deleteProspectAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/prospect/${id}`)
    commit('deleteProspectMutation', id)
    return id
  },
  nextProspectAction({commit}) {
    commit('nextProspectMutation')
  },
  prevProspectAction({commit}) {
    commit('prevProspectMutation')
  },
  async syncProspectGroupAction({commit}, {id, formParams}) {
    const {data} = await axios.post(`${apiUrl}/prospect/${id}/groupe/sync`, formParams)
    return data
  },
  async batchProspectAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/prospect/batch`, formParams)
    return data
  }
}

const mutations: MutationTree<ProspectState> = {
  getProspectsCountMutation(state, data) {
    state.count = data.count
  },
  getProspectsMutation(state, data) {
    state.prospects = data.data
  },
  getProspectByIdMutation(state, data) {
    state.prospect = data
  },
  saveProspectSortParamsMutation(state, data) {
    state.sortParams = data
  },
  saveProspectFilterParamsMutation(state, data) {
    state.filterParams = data
  },
  saveProspectLimitParamMutation(state, data) {
    state.limitParam = data
  },
  saveProspectPaginationParamsMutation(state, data) {
    state.paginationParams = data
  },
  deleteProspectMutation(state, id) {
    const index = state.prospects.findIndex((item) => item.ID === id)
    if (index > -1) Vue.delete(state.prospects, index)
  },
  nextProspectMutation(state) {
    const prospects = state.prospects
    const prospect = state.prospect
    const index = prospects.findIndex((item) => item.ID === prospect.ID)
    if (index < prospects.length - 1) {
      const {ID} = prospects[index + 1]
      router.replace(`/prospect/${ID}/fiche`)
    } else {
      const {ID} = prospects[0]
      router.replace(`/prospect/${ID}/fiche`)
    }
  },
  prevProspectMutation(state) {
    const prospects = state.prospects
    const prospect = state.prospect
    const index = prospects.findIndex((item) => item.ID === prospect.ID)
    if (index > 0) {
      const {ID} = prospects[index - 1]
      router.replace(`/prospect/${ID}/fiche`)
    } else {
      const {ID} = prospects[prospects.length - 1]
      router.replace(`/prospect/${ID}/fiche`)
    }
  },
  resetProspectMutation(state) {
    state.prospect = null
  }
}

export const prospect: Module<ProspectState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
